import axios from 'axios';
import { message } from 'antd';

// 创建axios实例
const request = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || 'https://ylchat-api.bcbx.cc',
  timeout: 10000,
});

// 请求拦截器
request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  response => {
    if (response.data.code === 0) {
      return response.data.data;
    }
    message.error(response.data.message || '请求失败');
    return Promise.reject(new Error(response.data.message || '请求失败'));
  },
  error => {
    if (error.response && error.response.status === 401) {
      // 未授权，重定向到登录页
      localStorage.removeItem('token');
      message.error('登录已过期，请重新登录');
      
      // 使用setTimeout来确保消息显示后再跳转
      setTimeout(() => {
        window.location.href = '/#/login';
      }, 1500);
    }
    message.error(error.message || '网络错误');
    return Promise.reject(error);
  }
);

export default request; 